import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const StickyCTA = dynamic(() => import('./StickyCTA'));

Builder.registerComponent(StickyCTA, {
	name: 'StickyCTA',
	inputs: [
		{
			name: 'displayUpperCopy',
			friendlyName: 'Display Upper Copy',
			type: 'boolean',
			defaultValue: false,
			helperText: 'Toggle to show/hide upper copy section',
		},
		{
			name: 'upperCopy',
			friendlyName: 'Upper Copy',
			type: 'richText',
			helperText: 'Text to display above the buttons',
			defaultValue: '<h4>Upper copy text</h4>',

			showIf: function (options) {
				return options.get('displayUpperCopy') === true;
			},
		},
		{
			name: 'displayLowerCopy',
			friendlyName: 'Display Lower Copy',
			type: 'boolean',
			defaultValue: false,
			helperText: 'Toggle to show/hide lower copy section',
		},
		{
			name: 'lowerCopy',
			friendlyName: 'Lower Copy',
			type: 'richText',
			helperText: 'Text to display below the buttons',
			defaultValue: '<h4>Lower copy text</h4>',

			showIf: function (options) {
				return options.get('displayLowerCopy') === true;
			},
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: '#ffffff',
			helperText: 'Background color for the sticky CTA bar',
		},
	],
	canHaveChildren: true,
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'Button',
				options: {
					copy: 'Get My Free Case Review',
					arrow: false,
					color: 'rgba(17, 186, 0, 1)',
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a Button.',
		query: { 'component.name': { $eq: 'Button' } },
	},
	image: getIconUrl(Icon.CTASection),
	friendlyName: 'Sticky CTA',
	description: 'A sticky call-to-action that appears at the bottom when the form is out of view',
});
